<template>
    <footer :class="['order-footer', {'order-footer--fullscreen': fullscreen, 'order-footer--is-mobile': isMobile}]">
        <div>
            <button id="backBtn" class="btn btn-icon-left btn-light text-uppercase" :class="{'btn-large-shadow': fullscreen}" @click.prevent="back">
                <span class="material-icon icon-keyboard_arrow_left"></span>
                <template v-if="!isMobile">
                    {{ $t('back') }}
                </template>
            </button>
            <ul v-if="isMobile" class="mobile-menu__actions">
                <li class="mobile-menu__action">
                    <a href="#" @click.prevent="$emit('close-order-set')" class="action-link">
                        <span class="material-icon icon-clear"></span>
                        <span class="action-link__txt">{{ $t('cancel') }}</span>
                    </a>
                </li>
            </ul>
        </div>
        <div>
            <button v-if="!!set.products.length && !photosView && !viewProduct" id="nextBtn"
                    :class="[`btn-${allowOrder ? 'success' : 'light'}`, {'btn-disabled': !allowOrder, 'btn-icon-left': !isMobile}]"
                    class="btn btn-shadow text-uppercase" @click.prevent="next">
                <span class="material-icon icon-add_shopping_cart"/>
                <template v-if="!isMobile">
                    <template v-if="uuid">
                        {{ $t('confirm') }}
                    </template>
                    <template v-else>
                        {{ $t('add_to_cart') }}
                    </template>
                </template>
            </button>
        </div>
    </footer>
</template>

<script>
  import setFooter from 'src/mixins/setFooterComponent';

  export default {
    mixins: [setFooter],
  };
</script>
